import { BRAND, SUBTITLE, TAGLINE } from "@/lib/content";

export default function Footer() {
  return (
    <footer className="px-6 md:px-16 pt-16 pb-10" data-testid="site-footer">
      <div className="gold-line mb-12" />
      <div className="flex flex-col md:flex-row justify-between gap-8">
        <div>
          <p className="font-display text-2xl gold-text">{BRAND}</p>
          <p className="font-heading text-sm text-[#f7f1e1]/70 mt-2">{SUBTITLE}</p>
          <p className="italic text-gold-soft mt-3">"{TAGLINE}"</p>
        </div>
        <a href="#request" data-testid="footer-request-link" className="self-start btn-gold rounded-full px-8 py-3 font-heading text-xs tracking-widest">REQUEST A SESSION</a>
      </div>
      <p className="text-xs text-[#f7f1e1]/40 mt-12">© {new Date().getFullYear()} Queen Boyce · earthangelstarseed.com</p>
    </footer>
  );
}
